import { Button, Switch } from 'hljd'
import React from 'react'
import { isStoreAccount } from '@util'
import style from '../style.module.less'

export default store => [
  {
    title: '客户信息',
    dataIndex: '',
    key: 'user',
    width: 129,
    render: (t, { lead, show_remark_message, status, time_remain }) => {
      lead = lead || {}
      const expired = status == 2 || (status == 0 && time_remain == 0)
      return (
        <div>
          <div className={style.userName}>
            {lead.name}
            {show_remark_message == 1 &&
              !expired && <p className={style.tip}>新消息</p>}
          </div>
          <p>{lead.phone}</p>
        </div>
      )
    }
  },
  {
    title: '推荐时间',
    dataIndex: '',
    key: 'created_at',
    width: 116,
    render: ({ created_at }) => {
      return (
        <div>
          <p>{(created_at || '').substring(0, 10)}</p>
          <p>{(created_at || '').substring(11)}</p>
        </div>
      )
    }
  },
  {
    title: '需求类型',
    key: 'property',
    width: 116,
    render: (text, record) => {
      return (
        <span>{record.order.property ? record.order.property.name : ''}</span>
      )
    },
    hidden: !isStoreAccount()
  },
  {
    title: '需求备注',
    dataIndex: '',
    key: 'feedback',
    width: 213,
    render: ({ order }) => order.remark
  },
  {
    title: '对接人',
    dataIndex: '',
    key: 'pickUp',
    width: 129,
    render: data => {
      const { admin, exp_saler, merchant_customer_id, operator } = data
      return (
        <div>
          {/* 加盟店显示最新操作人*/}
          {isStoreAccount() &&
          merchant_customer_id &&
          merchant_customer_id !== '0' ? (
            <p>
              <span style={{ color: '#999' }}>最新操作人：</span>
              {operator}
            </p>
          ) : null}

          {/* 非加盟店才显示销售 */}
          {!isStoreAccount() ? (
            <p>
              <span style={{ color: '#999' }}>销售：</span>
              {exp_saler}
            </p>
          ) : null}

          <p>
            <span style={{ color: '#999' }}>派单：</span>
            {admin && admin.nickname}
          </p>
        </div>
      )
    }
  },
  {
    title: '状态',
    dataIndex: '',
    key: 'status',
    width: 120,
    render: ({ status, time_remain, id }) => {
      let msg = '无效'
      let _id = ''
      switch (status + '') {
        case '0':
          msg = '未查看'
          if (time_remain == 0) {
            msg = '已过期'
          } else {
            store._ts = time_remain
            _id = 'time_' + id
            setTimeout(() => {
              store.formatSeconds(id, _id)
            }, 1000)
          }
          break
        case '1':
          msg = '已查看'
          break
        case '2':
          msg = '已过期'
          break
        case '3':
          msg = '已查看'
          break
        case '4':
          msg = '跟进失败'
          break
        case '5':
          msg = '已成单'
          break
        case '6':
          msg = '已退单'
          break
      }
      return (
        <div id={`${_id}btn`}>
          <p>{msg}</p>
          <p
            id={_id}
            style={{
              color: '#ff5c5c',
              display: status + '' === '0' ? 'block' : 'none'
            }}
          />
        </div>
      )
    }
  },
  {
    title: '已到店',
    dataIndex: '',
    key: 'come',
    width: 84,
    render: ({ is_come, id, status }) => (
      <Switch
        checked={is_come + '' === '1'}
        onChange={store.comeMerchant(is_come, id, status)}
      />
    )
  },
  {
    title: '操作',
    dataIndex: '',
    key: 'operation',
    width: 98,
    render: ({ id, disabled }) => {
      return (
        <Button
          type="primary"
          id={'btn_' + id}
          onClick={store.toDetail(id)}
          disabled={disabled}
        >
          查看详情
        </Button>
      )
    }
  }
]
